const labels = {
  changeBackground: 'Change Background',
  contactInfo: 'Contact Info',
  chat: 'Chat',
  typeYourMessage: 'Type your message ...'
}

export default labels
